export const IconPencilFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="m3.986 21.191 5.303-1.06a1 1 0 0 0 .51-.274l6.65-6.65a1 1 0 0 0 0-1.414L12.208 7.55a1 1 0 0 0-1.414 0l-6.65 6.65a1 1 0 0 0-.273.511l-1.061 5.303a1 1 0 0 0 1.177 1.177M20.192 5.222l-1.414-1.414a3 3 0 0 0-4.242 0l-.986.985a1 1 0 0 0 0 1.414l4.243 4.243a1 1 0 0 0 1.414 0l.985-.986a3 3 0 0 0 0-4.242" />
    </svg>
  );
};
